import * as S from "./style";
import contato from "../../assets/img/logo-contato.png";

import Footer from "../../components/Footer";
import Header from "../../components/Header";
import {
  ContactFormContext,
  IUserInputs,
} from "../../context/ContactFormDataContext";
import useAjvValidationWithCtx from "../../hooks/useAjvValidationWithCtx";
import CustomInput from "../../components/CustomInput";
import { SyntheticEvent, useCallback, useContext, useEffect, useState } from "react";
import CustomSelect from "../../components/CustomSelect";
import CustomTextArea from "../../components/CustomTextArea";
import { AxiosSendContact, Contact } from "../../domain/AxiosSendContact";
import { handleContactSend } from "../../utils/gtm";

export default function Contato() {
  const {
    formData: { errors, userInputs },
  } = useContext(ContactFormContext);

  const { checkIsValid, isValid, formData, resetValues } = useAjvValidationWithCtx(ContactFormContext);
  const [hasErrors, updateHasErrors] = useState(false);
  const [submiting, setSubmiting] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleSubmit = useCallback(async (e: SyntheticEvent) => {
    e.preventDefault();
    e.stopPropagation();
    setSubmiting(true)
    checkIsValid();
    const sendContact = new AxiosSendContact()
    const contact: Contact = {
      document: userInputs.cpf,
      email: userInputs.email,
      message: userInputs.msg,
      name: userInputs.name,
      phone: userInputs.phone,
      subject: userInputs.subject,
      zip: userInputs.cep
    }
    await sendContact.post(contact)
    setSubmiting(false)
    setSuccess(true)
  }, [userInputs, checkIsValid])

  const renderErrors = () => {
    const errorElements: (boolean | JSX.Element)[] =
      errors &&
      Object.keys(errors).map((name) => {
        const errorString = errors[name as keyof IUserInputs]
        if (errorString.length > 0) {
            return (
              <div key={name}>
                <span className="error-msg">
                  {errorString}
                </span>
                <span className="error-icon">!</span>
              </div>
            );
        }
        return false;
      });
    return errorElements;
  };

  const handleSubmitValues = () => {
    if (isValid) {
      console.log(isValid);
      handleContactSend(
          formData.userInputs.subject,
          formData.userInputs.cep,
          formData.userInputs.phone,
          formData.userInputs.email,
          formData.userInputs.name,
          formData.userInputs.cpf,
          formData.userInputs.msg,
      )

    }
    resetValues();
  }

  useEffect(() => {
    const checkErrors = Object.keys(errors).map(
      (error) => errors[error as keyof IUserInputs] !== ""
    );
    if (checkErrors.includes(true)) {
        return updateHasErrors(true);
    }
    updateHasErrors(false);
    return;
  }, [errors]);

  useEffect(() => {
    handleSubmitValues()
  }, [isValid]);

  return (
    <>
      <Header />
      <S.Principal>
        <div className="grid">
          <div className="contato">
            <img src={contato} alt="logo contato" />
            <div className="fones">
              <h1>
                ENTRE EM
                <br />
                CONTATO
              </h1>
              <p>Central de Vendas:</p>
              <a href="tel:08007238899">0800 723 8899</a>
              <p>SAC:</p>
              <a href="tel:08002838916">0800 283 8916</a>
            </div>
          </div>

          <div className="form">
            {!success ? <form action="">
              <CustomSelect name="subject" />
              <CustomInput type="text" name="name" placeholder="*Nome" />
              <CustomInput type="text" name="email" placeholder="*E-mail" />
              <CustomInput type="text" name="cpf" placeholder="*CPF" />
              <CustomInput type="text" name="phone" placeholder="*Telefone" />
              <CustomInput type="text" name="cep" placeholder="*CEP" />
              <CustomTextArea name="msg" />
              {hasErrors && !isValid && renderErrors()}
              <button
                onClick={handleSubmit}
                type="button"
                disabled={submiting}
              >
                {submiting ? `ENVIANDO...` : `ENVIAR`}
              </button>
            </form> : <S.SuccessMessage>Sua mensagem foi enviada com sucesso!</S.SuccessMessage>}
          </div>
        </div>
      </S.Principal>

      <Footer />
    </>
  );
}
